import styled from "styled-components";
import { Box, SpanStyled } from "../../../styled/Elements";

const MultipleTogglePopup= ({ setShowMultipleUsersModal, icon, selPlaceholder }) => {
	return (
		<MultipleUsersUpload>

			<Box className="addUserBtn" onClick={() => setShowMultipleUsersModal(true)}
			>
				<Box className="userPlaceholder">
        {icon}
				</Box>
				<SpanStyled className="pt-1" color="var(--text2)" size="14px" >
        {selPlaceholder}
				</SpanStyled>
			</Box>

		</MultipleUsersUpload>
	);
};

export default MultipleTogglePopup;

const MultipleUsersUpload = styled.div`
  // display: flex;
  // gap: 15px;
  // align-items: center;
  // overflow: hidden;
  // position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* padding-left: 32px; */
  .addUserBtn {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 7px 16px;
    border-radius: 10px;
    background-color: var(--bgSecondary);
  }
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    /* background-color: var(--greyBg); */
    border-radius: 50%;
    border: 1px dashed var(--text2);
    overflow: hidden;
    svg {
      width: 14px;
      height: auto;
      [stroke] {
        stroke: var(--text2);
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .selected.dropdown-item {
    background-color: var(--greyBg);
  }
`;
